export default __webpack_public_path__ + "static/sustain1-c287ecf3b9bba04a9ea860b0d6e51bad.webp";